import clsx from 'clsx';

export function getContractLinkStyle(isLink: boolean) {
  return clsx(
    isLink ? 'text-primary_400 opacity-100 cursor-pointer hover:opacity-80' : 'cursor-default',
  );
}
